import { BrowserRouter, Routes, Route } from 'react-router-dom'
import MainLayout from '@/layouts/MainLayout'
import Home from '@/pages/Home'
import Discover from '@/pages/Discover'
import Create from '@/pages/Create'
import MyWorks from '@/pages/MyWorks'
import Settings from '@/pages/Settings'
import StoryDetail from '@/pages/StoryDetail'
import { ToastProvider } from "@/components/ui/toast"
import { Toaster } from "@/components/ui/toaster"

function App() {
  return (
    <ToastProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<MainLayout />}>
            <Route index element={<Home />} />
            <Route path="discover" element={<Discover />} />
            <Route path="create" element={<Create />} />
            <Route path="my-works" element={<MyWorks />} />
            <Route path="settings" element={<Settings />} />
            <Route path="story/:id" element={<StoryDetail />} />
          </Route>
        </Routes>
      </BrowserRouter>
      <Toaster />
    </ToastProvider>
  )
}

export default App 